export const calculateTimeDifference = (startTime, endTime) => {
  if (!startTime || !endTime || !startTime.isValid() || !endTime.isValid()) {
    return '';
  }

  const diffInMinutes = endTime.diff(startTime, 'minute');
  const hours = Math.floor(diffInMinutes / 60);
  const minutes = diffInMinutes % 60;

  const formattedMinutes = String(minutes).padStart(2, '0');

  return `${hours}:${formattedMinutes}`;
};
